import auth from '@/router/auth'
import TestKitCreate from '@/components/test-kits/Create'
import TestKitUpdate from '@/components/test-kits/Update'
import TestKitShow from '@/components/test-kits/Show'

export default [
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-kits/create',
    name: 'test-kits-create',
    component: TestKitCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-kits/update/:test_kit_id',
    name: 'test-kits-update',
    component: TestKitUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/test-kits/show/:test_kit_id',
    name: 'test-kits-show',
    component: TestKitShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/test-kits/router.js